import React, { useEffect } from 'react'
import "./projects.css"
import LocalSwiper from '../../../components/LocalSwiper/LocalSwiper'
import useScrollReveal from "../../../hooks/useScrollReveal";

const Projects = () => {
  useScrollReveal();

  return (
    <div className='parentMaxWidth'>
      <div id="Projects" className='projectsMainWrapper'>
        <h2 className='SectHeader'>
          <span className="reveal-word">Recent</span>
      <span className="reveal-word">Projects</span>
        </h2>

        <div className='grad-container'>
          <div className='grad-background'></div>
          <LocalSwiper />
        </div>
      </div>
    </div>
  )
}

export default Projects
